module.exports = __webpack_public_path__ + "static/media/2017.ff545670.png";